import * as React from 'react';
import { WorkerNavLinkType } from '@restworld/utils-common';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface INonAuthenticatedNavProps {
  onStartLogin: () => void;
  onStartSignup: () => void;
  primaryItems?: WorkerNavLinkType[];
  secondaryItems?: WorkerNavLinkType[];
  children?: React.ReactNode;
}

export const NonAuthenticatedNav: React.FunctionComponent<INonAuthenticatedNavProps> = ({ children }) => {
  return <div className="flex-row items-center justify-between gap-4  w-full hidden md:flex">{children}</div>;
};

export default NonAuthenticatedNav;
